import { createContext } from 'react'

/** `system` follows `prefers-color-scheme`; the other two pin the theme. */
export type ThemePreference = 'light' | 'dark' | 'system'
export type ResolvedTheme = 'light' | 'dark'

export const THEME_STORAGE_KEY = 'saltseed.theme'

export interface ThemeContextValue {
  preference: ThemePreference
  resolved: ResolvedTheme
  setPreference: (preference: ThemePreference) => void
  /** Flips between light and dark, pinning the result. */
  toggle: () => void
}

export const ThemeContext = createContext<ThemeContextValue | undefined>(undefined)
